export default "__VITE_ASSET__CERMsiMH__"